/**
 * Concatenation of labels: "label[0], label[1], label[2] ... and label[N]" if they are not empty
 *
 * If there are no labels, return '—'
 * If there is only one label, return the label
 * If there are two or more labels, return the labels concatenated with ',' and 'and' before the last label
 */
export const concatenateLabels = (labels: string[]) => {
  if (labels.length === 0) {
    return '—';
  }

  if (labels.length === 1) {
    return labels?.[0] ?? '—';
  }

  const lastLabel = labels[labels.length - 1];
  const otherLabels = labels.slice(0, -1);

  return `${otherLabels.join(', ')} and ${lastLabel}`;
};
